export const EMPTY_CONDITION = {
  variableName: null,
  comparator: null,
  otherValue: null,
};
